import { BrandConfig } from './types'
import { justOnlyConfig } from './just-only/config'
import { fightforyouConfig } from './fightforyou/config'
import { getBrand, BrandType } from '../config'

// ブランド設定の取得
export const getBrandConfig = (): BrandConfig => {
  const brand = getBrand()
  switch (brand) {
    case 'fightforyou':
      return fightforyouConfig
    case 'just-only':
    default:
      return justOnlyConfig
  }
}

// 現在のブランド設定をエクスポート
export const brandConfig = getBrandConfig()

// 個別のブランド設定もエクスポート（テスト用など）
export { justOnlyConfig, fightforyouConfig }
export type { BrandConfig, BrandType }

// よく使用される値をエクスポート
export const {
  appName,
  appUrl,
  hashtag,
  metaDescription,
  contactUrl,
  userFaqUrl,
  creatorAndBusinessFaqUrl,
  creatorRegistrationUrl,
  creatorBankAccountRegistrationUrl,
  socialTwitterUrl,
  socialFacebookUrl,
  socialInstagramUrl,
  socialYoutubeUrl,
  primaryColor,
  secondaryColor,
} = brandConfig
